import { createActions } from 'redux-actions';

const ServiceWorkerActions = createActions({
  INIT: () => {},
  UPDATE: (registration) => ({ registration }),
  CHANGELANG: (lang) => ({ lang }),
});

export default ServiceWorkerActions;
